import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {BehaviorSubject, catchError, map, Observable, throwError} from 'rxjs';
import {Router} from "@angular/router";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private userSubject: BehaviorSubject<any>;
  public user: Observable<any>;
  public log: any;
  constructor(private http: HttpClient,private router: Router,) {
    this.userSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('user')!));
    this.log = localStorage.getItem('user');
    this.user = this.userSubject.asObservable();
  }

  signup(payload: any): Observable<any> {
    return this.http.post<any>(`${environment.baseHref}api/v1/auth-service/user/signup`, payload);
  }
  validateOTP(payload: any): Observable<any> {
    return this.http.post<any>(`${environment.baseHref}api/v1/auth-service/user/validate-otp`, payload);
  }
  resendOTP(payload: any): Observable<any> {
    return this.http.post<any>(`${environment.baseHref}api/v1/auth-service/user/reset-otp`, payload);
  }
  sendOTP(payload: any): Observable<any> {
    return this.http.post<any>(`${environment.baseHref}api/v1/auth-service/user/resend-otp`, payload);
  }
  login(payload: any): Observable<any> {
    return this.http.post<any>(`${environment.baseHref}api/v1/auth-service/user/user-signin`, payload).pipe(map(user => {

          if(user.success){
            localStorage.setItem('user', JSON.stringify(user));
            this.userSubject.next(user);
          }
          return user;

        }),
        catchError(this.handleError.bind(this)));
  }
  resetPassword(payload: any): Observable<any> {
    return this.http.post<any>(`${environment.baseHref}api/v1/auth-service/user/reset-password`, payload);
  }
  logout() {
    localStorage.removeItem('user');
    this.userSubject.next(null);
    this.router.navigate(['/']);
  }
  public get userValue() {
    return this.userSubject.value;
  }
  private handleError(error: HttpErrorResponse) {
    let msg = '';
    if (error.error instanceof ErrorEvent) {
      // Client-side error
      msg = error.error.message;
    } else {
      // Server-side error
      msg = `${error.error.error}`;
    }
    return throwError(() => new Error(msg));
  }
  userProfile(userId: any): Observable<any> {
    console.log("user profile called",userId);
    return this.http.get<any>(`${environment.baseHref}api/v1/user-service/user-account?userId=${userId}`);
  }

}
